/**
 login-view
 Created by RuSsCiTy on 07.05.2018
 **/

import Backbone from "backbone";
import { viewChannel } from "../../init/message-hub";
import { PAGES } from "../../const/constants";

const template = require("./template.pug");

require("./style.scss");

export default Backbone.View.extend({
  className: "preferencesBtn",

  events: {
    "click .btn-primary": "openPreferences"
  },

  initialize(container, position) {
    this.render(container);
    this.doPosition(position);
  },

  render(container) {
    this.$el.html(template);
    container.html(this.$el);
    this.hide();
  },

  show() {
    this.$el.show();
  },

  hide() {
    this.$el.hide();
  },

  doPosition(position) {
    const positions = position.split(" ");
    for (let i = 0; i < positions.length; i++) {
      this.$el.css(positions[i], "10px");
    }
  },

  openPreferences() {
    viewChannel.request("showPage", PAGES.intro);
  }
});



// WEBPACK FOOTER //
// ./src-cookie-manager/views/preferences-button/preferences-button-view.js